import type React from 'react';

import type { CommentToScriptArm } from '#src/app/pages/actions/shared/hooks';

import { AddSupporterVoiceThankYou } from '../AddSupporterVoiceThankYou';

export const CommentToScriptWelcome: React.FC<Props> = ({ arm, ref }) => (
	<div data-testid="comment-to-script-welcome" data-arm={arm}>
		<AddSupporterVoiceThankYou ref={ref} />
	</div>
);

type Props = {
	arm: CommentToScriptArm;
	ref?: React.Ref<HTMLDivElement>;
};
